module.exports = __webpack_public_path__ + "static/media/specifications.c2772313.pdf";